<template>
  <div class="unlimited-autopost-page">
    <div class="header">
      <!-- <div class="upgrade-btn"
           @click="upgradeClick">Upgrade Plan</div> -->
    </div>
    <div class="main-container">
      <div class="header-container">
        <div class="left">
          <div class="title">
            {{ title }}
            <div class="des-info">
              <div class="ins-icon"></div>
              <div class="text">{{ insInfo }}</div>
            </div>
            <div class="des-info" style="margin-left: 20px">
              <div class="fb-icon"></div>
              <div class="text">{{ fbInfo }}</div>
            </div>
            <div class="des-info" style="margin-left: 20px">
              <div class="tw-icon"></div>
              <div class="text">{{ twInfo }}</div>
            </div>
          </div>
          <div class="tip-message">
            Add your social account to unlimited schedules.
          </div>
        </div>
        <div
          v-if="list.length !== 0"
          class="add-user-btn"
          @click="addUnlimitedPublisher"
        >
          <div class="icon"></div>
          <div class="text">Add Social Account</div>
        </div>
      </div>
      <div
        v-if="list.length === 0"
        class="add-user-btn"
        @click="addUnlimitedPublisher"
      >
        <div class="icon"></div>
        <div class="text">Add Social Account</div>
      </div>
      <div v-if="list.length !== 0" class="list-main-container">
        <list-item
          v-for="publisher in list"
          :key="publisher.id"
          :item="publisher"
          @removeClick="remove"
        >
        </list-item>
      </div>
    </div>
    <select-dialog ref="selectModal"></select-dialog>
  </div>
</template>

<script>
import selectDialog from "../../components/plan/unlimited_auto/SelectDialog";
import listItem from "../../components/plan/unlimited_auto/ListItem";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/errors";
import { mulModifyUnlimited } from "../../service/publisher";

export default {
  name: "AccountAddInstagramPage",
  components: {
    listItem,
    selectDialog,
  },
  methods: {
    /**
     * 升级按钮点击事件
     */
    upgradeClick() {
      this.$router.push({ name: "UpgradePage" });
    },
    // 添加Ins点击事件
    async addUnlimitedPublisher() {
      // 判断是否已经无用户可添加
      if (this.freeNum === 0) {
        await this.$confirm.show({
          text: "Please add an Instagram account first.",
          yesText: "Add",
        });
        this.$bus.$emit("showAddIns", {});
        return;
      }
      this.$refs.selectModal.open({
        title: this.title,
      });
    },
    /**
     * 删除选项
     * @param item 对应项
     */
    async remove(item) {
      const loading = this.$loading();
      try {
        await mulModifyUnlimited({ ids: [item.id], isPremium: false });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    insInfo() {
      const unlimitedPublishers = this.user.linkedInstagramList.filter(
        (l) =>
          l.isUnlimited &&
          !l.isMember &&
          l.status !== 2 &&
          l.socialNetwork === 1
      );
      if (this.user.plan.premiumInstagramPublisherCount === 32767) {
        return `Unlimited`;
      }
      return `${unlimitedPublishers.length}/${this.user.plan.premiumInstagramPublisherCount}`;
    },
    fbInfo() {
      const unlimitedPublishers = this.user.linkedInstagramList.filter(
        (l) => l.isUnlimited && (l.socialNetwork === 2 || l.socialNetwork === 3)
      );
      if (this.user.plan.premiumFacebookPublisherCount === 32767) {
        return `Unlimited`;
      }
      return `${unlimitedPublishers.length}/${this.user.plan.premiumFacebookPublisherCount}`;
    },
    twInfo() {
      const unlimitedPublishers = this.user.linkedInstagramList.filter(
        (l) => l.isUnlimited && l.socialNetwork === 4
      );
      if (this.user.plan.premiumTwitterPublisherCount === 32767) {
        return `Unlimited`;
      }
      return `${unlimitedPublishers.length}/${this.user.plan.premiumTwitterPublisherCount}`;
    },
    /**
     * 计算列表
     * @returns {Array}
     */
    list() {
      // 根据类型进行分组(过滤掉member和已选择的unlimited账号，同时去掉无密码用户)
      let list = this.user.linkedInstagramList
        .filter((l) => !l.isMember && l.status !== 2 && l.isUnlimited)
        .sort((a, b) => {
          return !a.wasPremium && b.wasPremium;
        });
      return list;
    },
    title() {
      let title = this.$t("myPlanPage.unlimitedInfo.title");
      return title;
    },
    /**
     *
     */
    unlimitedNum() {
      // 根据类型进行分组(只保留unlimited)
      const users = this.user.linkedInstagramList
        .filter((l) => l.isUnlimited && !l.isMember)
        .map((l) => {
          return {
            image: l.image,
            username: l.username,
          };
        });
      return users.length;
    },
    freeNum() {
      const users = this.user.linkedInstagramList.filter(
        (l) => !l.isUnlimited && !l.isMember
      );
      return users.length;
    },
  },
};
</script>
<style>
.el-popover {
  padding: 0;
}
</style>
<style scoped lang="less">
.unlimited-autopost-page {
  height: 100vh;
  .header {
    height: 80px;
    padding-left: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
    .upgrade-btn {
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      background-color: #e72955;
      border-radius: 4px;
      color: white;
      cursor: pointer;
      &:active,
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .main-container {
    padding: 30px 60px;
    flex: 1;
    overflow: auto;
    min-width: 900px;
    .header-container {
      margin-bottom: 25px;
      display: flex;
      justify-content: space-between;
      .left {
        .title {
          font-size: 20px;
          font-weight: 600;
          display: flex;
          align-items: center;
          @icon-size: 17px;
          .des-info {
            margin-left: 10px;
            display: flex;
            align-items: center;
            .fb-icon {
              background-image: url("../../../public/images/common/fb@3x.png");
              width: @icon-size;
              height: @icon-size;
              background-size: contain;
            }
            .tw-icon {
              background-image: url("../../../public/images/common/tw@3x.png");
              width: @icon-size;
              height: @icon-size;
              background-size: contain;
            }
            .ins-icon {
              background-image: url("../../../public/images/common/ins@3x.png");
              width: @icon-size;
              height: @icon-size;
              background-size: contain;
            }
            .text {
              margin-left: 5px;
            }
          }
        }
        .tip-message {
          color: #5a5a5a;
          font-size: 16px;
          margin-top: 20px;
        }
      }
    }
    .add-user-btn {
      display: flex;
      align-items: center;
      cursor: pointer;
      &:active,
      &:hover {
        opacity: 0.8;
      }
      .icon {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../../../public/images/schedule_posts/Add_Detail@3x.png);
        background-size: contain;
      }
      .text {
        font-size: 16px;
        margin-left: 10px;
      }
    }
    .list-main-container {
      padding-top: 13px;
      border-top: 2px solid black;
      .publisher-list-item {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0 15px;
        cursor: pointer;
        .image {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background-position: center;
          background-size: cover;
        }
        .username {
          font-size: 16px;
          margin-left: 15px;
          flex: 1;
        }
      }
    }
  }
}
</style>
